import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type ForoTema } from "../lib/api";
import { PrivateLayout } from "../components/PrivateLayout";
import { Reveal } from "../components/Reveal";
import { CATEGORIES } from "../lib/categories";
import { relTime } from "../lib/time";

const FILTER_CATS = [{ id: "", label: "Todos los temas", dot: "" }, ...CATEGORIES];

export default function Comunidad() {
  const [temas,     setTemas]  = useState<ForoTema[]>([]);
  const [loading,   setLoad]   = useState(true);
  const [activeTab, setTab]    = useState("");

  useEffect(() => {
    setLoad(true);
    api.getForoTemas(activeTab || undefined)
      .then((r) => {
        console.log("Temas recibidos:", r);
        if (r.ok) setTemas(r.data.temas);
      })
      .catch(() => {})
      .finally(() => setLoad(false));
  }, [activeTab]);

  return (
    <PrivateLayout>
      <Reveal>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 30, letterSpacing: "-0.02em", margin: "0 0 4px" }}>
            Comunidad
          </h1>
          <p style={{ fontSize: 15, color: "var(--muted-2)", margin: 0 }}>
            Conversaciones acompañadas por el equipo de PzicoDosis. Un espacio seguro para compartir.
          </p>
        </div>
      </Reveal>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 250px", gap: 28, alignItems: "start" }} className="comunidad-grid">
        {/* thread list */}
        <div>
          <Reveal delay={1}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 9, marginBottom: 22 }}>
              {FILTER_CATS.map((c) => {
                const active = activeTab === c.id;
                return (
                  <button
                    key={c.id || "todos"}
                    onClick={() => setTab(c.id)}
                    className={`chip${active ? " chip--active" : ""}`}
                    style={{ fontSize: 13, padding: "8px 15px" }}
                  >
                    {!active && c.dot && <span className="chip__dot" style={{ background: c.dot }} />}
                    {c.label}
                  </button>
                );
              })}
            </div>
          </Reveal>

          {/* pinned by team */}
          <Reveal delay={2}>
            <div style={{
              background: "linear-gradient(135deg,#F2EADF,#EDE4D8)", border: "1px solid #E8D9C4",
              borderRadius: 18, padding: 20, marginBottom: 14,
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <span style={{ fontSize: 13, fontWeight: 800, color: "var(--copper)" }}>📌 Destacado por el equipo</span>
              </div>
              <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 18, marginBottom: 6 }}>
                Bienvenida: cómo cuidarnos en este espacio
              </div>
              <div style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.5 }}>
                Acuerdos de la comunidad para que sea un lugar seguro para todas las personas.
              </div>
            </div>
          </Reveal>

          {loading && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[1, 2, 3].map((i) => <div key={i} className="skeleton" style={{ height: 130 }} />)}
            </div>
          )}

          {!loading && temas.length === 0 && (
            <div style={{ textAlign: "center", padding: "3rem 1rem", color: "var(--muted-2)" }}>
              <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>🔍</div>
              <p>Aún no hay temas en esta categoría.</p>
            </div>
          )}

          {!loading && temas.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {temas.map((tema, i) => {
                const cat = CATEGORIES.find((c) => c.id === tema.categoria);
                return (
                  <Reveal key={tema.id} delay={(i % 4) as 0 | 1 | 2 | 3}>
                    <Link to={`/comunidad/${tema.id}`} className="card card--hover" style={{ padding: 20, display: "block", textDecoration: "none", color: "inherit" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 11, flexWrap: "wrap" }}>
                        {(() => {
                          const fotoUrl = tema.creador_foto_url ?? tema.creador_avatar_url;
                          const nombre = tema.creador_nombre ?? "Equipo PzicoDosis";
                          return fotoUrl ? (
                            <img src={fotoUrl} alt={nombre} style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
                          ) : (
                            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "linear-gradient(135deg,#C99A6E,#E2D2BB)", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 15 }}>
                              {nombre[0]?.toUpperCase()}
                            </div>
                          );
                        })()}
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 700 }}>{tema.creador_nombre ?? "Equipo PzicoDosis"}</div>
                          <div style={{ fontSize: 12, color: "var(--muted-3)" }}>{relTime(tema.created_at)}</div>
                        </div>
                        {cat && (
                          <span className="badge" style={{ marginLeft: "auto", background: cat.bg, color: cat.text }}>
                            <span className="badge__dot" style={{ background: cat.dot }} />{cat.label}
                          </span>
                        )}
                      </div>
                      <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 18, marginBottom: 6 }}>
                        {tema.titulo}
                      </div>
                      {tema.descripcion && (
                        <div style={{
                          fontSize: 14, color: "var(--muted)", lineHeight: 1.55, marginBottom: 14,
                          overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                        }}>
                          {tema.descripcion}
                        </div>
                      )}
                      <div style={{ display: "flex", alignItems: "center", gap: 20, color: "var(--muted-2)", fontSize: 13, fontWeight: 600 }}>
                        <span>💬 {tema.post_count} respuesta{tema.post_count !== 1 ? "s" : ""}</span>
                        <span>🕐 {relTime(tema.ultima_actividad)}</span>
                      </div>
                    </Link>
                  </Reveal>
                );
              })}
            </div>
          )}
        </div>

        {/* right rail */}
        <Reveal delay={1} className="hide-mobile" style={{ display: "flex", flexDirection: "column", gap: 18, position: "sticky", top: 32 }}>
          <div style={{
            background: "linear-gradient(150deg,#33302B,#413A31)", borderRadius: 20, padding: 22,
            color: "var(--on-dark)", position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", right: -30, top: -30, width: 120, height: 120, background: "radial-gradient(circle,var(--sage),transparent 70%)", opacity: 0.25 }} />
            {/* TODO: reemplazar por conteo real (ej. GET /usuario/count) cuando
                haya una base de usuarios significativa que mostrar. */}
            <div style={{ position: "relative", fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 19, marginBottom: 6 }}>
              Una comunidad que crece cada día
            </div>
            <div style={{ position: "relative", fontSize: 14, color: "var(--on-dark-muted)", lineHeight: 1.5 }}>
              Cada historia compartida acerca a más personas, contigo.
            </div>
          </div>

          <div className="card" style={{ padding: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "var(--copper)", marginBottom: 14 }}>
              Categorías
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 11, fontSize: 14 }}>
              {CATEGORIES.slice(0, 4).map((c) => (
                <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 9 }}>
                  <span style={{ width: 9, height: 9, borderRadius: "50%", background: c.dot }} />
                  {c.label}
                </div>
              ))}
            </div>
          </div>

          <div style={{ background: "var(--sand-3)", border: "1px solid #E8D9C4", borderRadius: 20, padding: 20, fontSize: 13, color: "var(--muted)", lineHeight: 1.55 }}>
            💛 Recuerda: la comunidad no reemplaza terapia. Si estás en crisis, busca ayuda profesional.
          </div>
        </Reveal>
      </div>
    </PrivateLayout>
  );
}
